import styled, { createGlobalStyle } from 'styled-components';
import { normalize } from 'polished';
import { fadeInAnimation } from 'app/client/styled/animations';
import theme from './theme';

import type from './type';
import base from './base';

export default createGlobalStyle`
  /* WebAwesome renders its brand variant in blue, and react-shared's Submit and
     Confirm buttons ask for that variant. The portal's action buttons are green,
     so remap the brand ramp to the success one on the element itself -- custom
     properties inherit into the shadow DOM, and at specificity 0,0,1 a button
     that sets its own brand tokens still wins. Same approach as the admin, but
     filled with the portal's own green rather than WebAwesome's success step. */
  wa-button {
    --wa-color-brand-95: var(--wa-color-success-95);
    --wa-color-brand-90: var(--wa-color-success-90);
    --wa-color-brand-80: var(--wa-color-success-80);
    --wa-color-brand-70: var(--wa-color-success-70);
    --wa-color-brand-60: var(--wa-color-success-60);
    --wa-color-brand-50: var(--wa-color-success-50);
    --wa-color-brand-40: var(--wa-color-success-40);
    --wa-color-brand-30: var(--wa-color-success-30);

    --wa-color-brand-fill-quiet: var(--wa-color-success-fill-quiet);
    --wa-color-brand-fill-normal: var(--wa-color-success-fill-normal);
    /* The filled action button is the portal's own green, not WebAwesome's. */
    --wa-color-brand-fill-loud: var(--btn-alt-bg, var(--green));
    --wa-color-brand-border-quiet: var(--wa-color-success-border-quiet);
    --wa-color-brand-border-normal: var(--wa-color-success-border-normal);
    --wa-color-brand-border-loud: var(--wa-color-success-border-loud);
    --wa-color-brand-on-quiet: var(--wa-color-success-on-quiet);
    --wa-color-brand-on-normal: var(--wa-color-success-on-normal);
    --wa-color-brand-on-loud: var(--wa-color-success-on-loud);
  }

  ${normalize()};

  :root {
    ${theme};
  }

  ${base}
  ${type}
`;

// Remounted (via key) when the top-level route segment changes, so a freshly
// loaded page eases in instead of appearing abruptly. Data loads within a page
// don't retrigger it, so skeleton-to-content swaps stay instant.
export const RouteTransition = styled.div`
  animation: ${fadeInAnimation} 0.15s ease-out;
`;
